import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingInfoComponent } from './billing-info/billing-info.component';
import { ContractPartnerInfoComponent } from './contract-partner-info/contract-partner-info.component';
import { ReferencesInfoComponent } from './references-info/references-info.component';
import { WizardBodyColumnComponent, WizardBodyComponent } from '@markant-platform/cartridge/ui-booking';
import { BookingDataForm, BookingWorkflowData } from '../../booking/model/booking.model';

@Component({
  selector: 'markant-platform-booking-form-content',
  standalone: true,
  imports: [
    CommonModule,
    BillingInfoComponent,
    ContractPartnerInfoComponent,
    ReferencesInfoComponent,
    WizardBodyColumnComponent,
    WizardBodyComponent,
  ],
  templateUrl: './booking-form-content.component.html',
  styleUrl: './booking-form-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingFormContentComponent {
  @Input({ required: true }) bookingDataForm!: BookingDataForm;
  @Input({ required: true }) bookingData!: BookingWorkflowData;
  @Input({ required: true }) submitted = false;
}
